import { useQuery } from '@tanstack/react-query';
import { getSubdomain, isAuthenticated } from '@zealy/utils';
import { twitterAutomationKeys } from '../twitterAutomation.keys';
import { mapBackendToFrontend } from '../twitterAutomation.mapper';
import { listAutomations } from '../twitterAutomation.service';
export const useListAutomations = (subdomain = getSubdomain()) => {
    return useQuery({
        queryKey: twitterAutomationKeys.list(subdomain),
        queryFn: async () => {
            const data = await listAutomations(subdomain);
            return data.map(mapBackendToFrontend);
        },
        enabled: isAuthenticated() && !!subdomain && subdomain !== 'root',
    });
};
